import { cloneCard } from "../services/cards";

export const autoCloneCard: any = async (postData: any, userId: string, cardDetails: any) => {
    try {
        const payload: any = {
            created_by: postData.created_by,
            last_modified_by: postData.last_modified_by,
            board_name: postData.board_name.trim(),
            position: postData.position,
            home_position: postData.home_position ?? postData.position,
            status: postData.status,
            priority: postData.priority,
            boardId: postData.boardId,
            board_column_id: postData.board_column_id,
            reporter: postData.reporter,
            cardType: 'individual',
            description: postData.description,
            card_name: postData.card_name,
            assignees: postData.assignees,
            due_date: postData.due_date,
            cardid: cardDetails.id,
            tagIds: cardDetails?.tags.length > 0 ? cardDetails?.tags?.map((tag: any) => tag.id) : [],
        };
        if (cardDetails.file_attachments && cardDetails.file_attachments.length > 0) {
            payload.file_attachments = cardDetails.file_attachments.map((file: any) => Object.values(file)[0]);
        }
        const res: any = await cloneCard(payload, userId);
        if (res.data.success) return res
        return null;
    } catch (error) {
        // console.log(error)
    }
};
